import { $getRoot, $isParagraphNode, $isTextNode } from 'lexical';

import { $isActionNode } from '../features/action/nodes/ActionNode';

/**
 * Custom serialization that concatenates text content with single line breaks between paragraphs.
 * Only handles ParagraphNode, ActionNode, and TextNode.
 *
 * @return {string}
 */
export function $serializeToRawText(): string {
  const root = $getRoot();
  const children = root.getChildren();
  let textContent = '';

  for (let i = 0; i < children.length; i++) {
    const child = children[i];

    // Handle paragraph nodes
    if ($isParagraphNode(child)) {
      const paragraphChildren = child.getChildren();
      let paragraphText = '';

      // Collect text from all children of paragraph (TextNode and ActionNode)
      for (const paragraphChild of paragraphChildren) {
        if ($isTextNode(paragraphChild) || $isActionNode(paragraphChild)) {
          paragraphText += paragraphChild.getTextContent();
        }
      }

      textContent += paragraphText;

      // Add single line break after paragraph if it's not the last node
      if (i < children.length - 1) {
        textContent += '\n';
      }
    }
  }

  return textContent;
}
